/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: TopBar for Login
Author: Deimos Space UK

Version: 1.0
*/
import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";


const TopBarLogin = ({ children }) => {

	return (
		<>
			<div style={{
				width: '100%',
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				height: '60px',
				zIndex: 2, 
				display: 'flex', 
				alignContent: 'center', 
				justifyContent: 'flex-end', 
				padding: '10px',
				background: "#003247" }}>
				<Row style={{ display: 'flex', alignContent: 'center' }}>
					<Col>
						{children}
					</Col>
					<ul className="list-unstyled topbar-menu float-end mb-0 mr-4">
						<li className="dropdown notification-list" >
							<Link
								style={{ 
									background: "white", 
									color: "#003247" ,
									padding: '10px',
									borderRadius: '5px',
									textDecoration: 'none'

								}}
								to="/login"
							>
								Login
							</Link>
						</li>
					</ul>

				</Row>
			</div>
		</>
	);
}
export default TopBarLogin
